import { Controller } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import { Input } from '@leroy-merlin-br/backyard-react-ui'

const NumberField = ({ control, name, rules, keepFormatted, ...props }) => (
  <Controller
    name={name}
    rules={rules}
    control={control}
    render={({ onChange, ref, value, name }) => (
      <NumberFormat
        name={name}
        customInput={Input}
        getInputRef={ref}
        value={value}
        onValueChange={event => onChange(keepFormatted ? event.formattedValue : event.value)}
        {...props}
      />
    )}
  />
)

export default NumberField
